import { CloudCheckIcon } from "assets/icons/CloudCheck";
import { TourAnchor } from "training/anchors";

import { SaveState } from "./useSaveStatus";

const LABELS: Record<SaveState, string> = {
  idle: "Draft",
  saving: "Saving…",
  saved: "All changes saved",
};

export function SaveStatus({ state }: { state: SaveState }) {
  return (
    <div
      data-testid="saveStatus"
      data-tour={TourAnchor.SaveStatus}
      className="flex align-items-center gap-2 text-sm white-space-nowrap"
      style={{ color: "var(--brand-gray-600)" }}
    >
      {state === "saving" && (
        <i className="pi pi-spin pi-spinner" style={{ fontSize: "1rem" }} />
      )}

      {state === "saved" && (
        <CloudCheckIcon style={{ color: "var(--green-600)" }} />
      )}

      <span>{LABELS[state]}</span>
    </div>
  );
}
